import { ScheduleWeek } from '@/model';
import {
  GetNewsCalendarScheduleWeekResponse,
  PostNewsCalendarScheduleWeekResponse,
  PutNewsCalendarScheduleWeekResponse,
} from '@/services/response/schedule-week';

export class ScheduleWeekConverter {
  static toDomainFromPostResponse(response: PostNewsCalendarScheduleWeekResponse): ScheduleWeek {
    return {
      uuid: response.uuid,
      days_of_week: response.days_of_week,
      description: response.description,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromGetResponse(response: GetNewsCalendarScheduleWeekResponse): ScheduleWeek[] {
    return response.map(item => ({
      uuid: item.uuid,
      days_of_week: item.days_of_week,
      description: item.description,
      created_at: item.created_at,
      updated_at: item.updated_at,
      business_unit_uuid: item.business_unit_uuid,
    }));
  }

  static toDomainFromPutResponse(response: PutNewsCalendarScheduleWeekResponse): ScheduleWeek {
    return {
      uuid: response.uuid,
      days_of_week: response.days_of_week,
      description: response.description,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
